import { SelectionRecord } from '@datum-group/datum-map/lib/Tools/BufferZone/types';
import {
  makeObservable,
  observable,
  computed,
  action,
  runInAction,
} from 'mobx';
import { Pagination } from './types';

export const DEFAULT_PAGINATION: Pagination = {
  total: 0,
  current: 1,
  pageSize: 10,
};

export class SelectedLayer {
  readonly name: string;
  readonly description?: string;
  readonly tableName: string;
  @observable private _records = new Set<string>();
  @observable private _pagination: Pagination = { ...DEFAULT_PAGINATION };

  constructor(name: string, table: string, description?: string) {
    this.name = name;
    this.description = description;
    this.tableName = table;

    makeObservable(this);
  }

  /** Возвращает все записи */
  @computed get allRecords() {
    return Array.from(this._records);
  }

  /** Возвращает часть записей согласно пагинации */
  @computed get records() {
    const { pageSize, current } = this.pagination;
    const startPosition = pageSize * (current - 1);
    const endPosition = startPosition + pageSize - 1;

    const result: string[] = [];
    const arr = Array.from(this._records);

    for (let i = startPosition; i <= endPosition; i++) {
      const record: string | undefined = arr[i];

      if (record !== undefined) result.push(record);
    }

    return result;
  }

  @computed get pageCount() {
    const { total, pageSize } = this.pagination;

    return Math.ceil(total / pageSize);
  }

  @computed get pagination() {
    return { ...this._pagination };
  }

  @action addSelection(selection: SelectionRecord) {
    const { layerName, layerDescription, tableName, recordId } = selection;

    if (
      this.name !== layerName ||
      this.tableName !== tableName ||
      this.description !== layerDescription
    ) {
      throw new Error('Объект не принадлежит данному слою');
    }

    runInAction(() => this._records.add(recordId));
    this._updateTotal();
  }

  @action setCurrent = (value: number) => {
    const { current } = this.pagination;

    if (current === value) return;

    this.pageCount;

    if (value < 1 || value > this.pageCount) {
      throw new Error(
        `Текущая страница не может быть больше ${
          this.pageCount
        } или меньше ${1}`,
      );
    }

    runInAction(() => (this._pagination.current = value));
  };

  @action setPageSize = (value: number) => {
    if (value < 1) {
      throw new Error(
        `Количество объектов на странице не может быть меньше ${1}`,
      );
    }

    runInAction(() => {
      this._pagination = { ...this._pagination, current: 1, pageSize: value };
    });
  };

  @action private _updateTotal() {
    this._pagination.total = this._records.size;
  }
}
